import { render, staticRenderFns } from "./performance.vue?vue&type=template&id=ac147fe4&scoped=true&"
import script from "./performance.vue?vue&type=script&lang=js&"
export * from "./performance.vue?vue&type=script&lang=js&"
import style0 from "./performance.vue?vue&type=style&index=0&id=ac147fe4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac147fe4",
  null
  
)

export default component.exports